export default __webpack_public_path__ + "static/media/image.olak-etraders-pvt-ltd.18412d21.png";